<template>
  <b-modal
    :id="id"
    :title="trans('placeholder')"
    :ok-title="trans('insert')"
    :ok-disabled="!placeholder"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onInsert"
  >
    <treeselect
      v-model="index"
      :options="options"
      :placeholder="trans('placeholder')"
      close-on-select
      disable-branch-nodes
      search-nested
      :clearable="false"
      @select="onSelect"
    >
    </treeselect>
    <br/>
    <p v-if="placeholder" class="px-4">
      <span style="background-color: #ffff00; padding: 3px;">{{ '{'+placeholder+'}' }}</span>
    </p>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="!!error" class="text-danger">
      {{ error }}
    </p>
    <br/>
  </b-modal>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'

  window.insertPlaceholderModalActiveEditor = null

  export default {
    props: {
      id: {
        type: String,
        default: 'insert-placeholder-modal',
      },
      organization: Object,
      placeholders: Object,
    },
    components: {
      Treeselect,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        all_placeholders: null,
        index: null,
        placeholder: null,
        grouped_placeholders: _.getGroupedPlaceholders(),
      }
    },
    computed: {
      formPlaceholders() {
        return _.reduce(this.all_placeholders || [], (placeholders, p) => {
          if (!!p.question_ids) placeholders.push(p.name)
          return placeholders
        }, [])
      },
      options() {
        let index = 0
        return _.reduce(_.keys(this.grouped_placeholders), (options, group) => {
          let children = _.map(this.grouped_placeholders[group], (placeholder) => {
            return {
              id: index++,
              label: placeholder
            }
          })
          if (group == 'Form' || group == 'Formulaire' && this.formPlaceholders.length > 0) {
            _.each(this.formPlaceholders, placeholder => {
              children.push({
                id: index++,
                label: placeholder
              })
            })
          }
          options.push({
            id: index++,
            label: group,
            children: children,
            isDefaultExpanded: true
          })
          return options
        }, [])
      },
    },
    methods: {
      onShown() {
        if (!this.all_placeholders && !this.busy) this.fetch()
      },
      onSelect(item) {
        this.placeholder = item.label
      },
      onInsert(e) {
        const editor = window.insertPlaceholderModalActiveEditor
        const selection = editor.model.document.selection;
        editor.model.change(writer => {
          // Create <placeholder> elment with name attribute...
          const placeholder = writer.createElement("placeholder", {
            ...Object.fromEntries( selection.getAttributes() ),
            name: this.placeholder,
          });

          // ... and insert it into the document.
          editor.model.insertContent(placeholder);

          // Put the selection on inserted element.
          writer.setSelection(placeholder, "on");
        })
      },
      fetch() {
        if (!this.organization) {
          this.all_placeholders = []
          return
        }
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/form/placeholders?lang=${window.lang}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.all_placeholders = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.insertPlaceholderModal = this
    },
    // static method
    buildSimpleButton(component, id) {
      id || (id = 'insert-placeholder-modal')
      return {
          name: _.camelCase(id.replace('-modal', '')),
          label: trans('placeholder'),
          icon: '<svg version="1.1" viewBox="0.0 0.0 131.0 100.0" fill="none" stroke="none" stroke-linecap="square" stroke-miterlimit="10" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><clipPath><path d="m0 0l131.0 0l0 100.0l-131.0 0l0 -100.0z" clip-rule="nonzero"/></clipPath><g clip-path="url(#p.0)"><path fill="#000000" fill-opacity="0.0" d="m0 0l131.0 0l0 100.0l-131.0 0z" fill-rule="evenodd"/><path fill="#ffff00" d="m0 0l130.99213 0l0 100.0l-130.99213 0z" fill-rule="evenodd"/><path fill="#000000" fill-opacity="0.0" d="m-4.0 -22.52756l170.99213 0l0 139.05511l-170.99213 0z" fill-rule="evenodd"/><path fill="#000000" d="m33.3125 92.36681q1.0625 0 1.640625 0.46875q0.578125 0.484375 0.578125 1.34375q0 0.765625 -0.578125 1.25q-0.578125 0.484375 -1.640625 0.484375l-6.140625 0q-7.875 0 -7.875 -8.15625l0 -24.671875q0 -4.03125 -1.625 -5.90625q-1.625 -1.875 -5.65625 -1.96875q-1.15625 -0.09375 -1.6875 -0.578125q-0.53125 -0.484375 -0.53125 -1.25q0 -1.71875 2.21875 -1.828125q4.03125 -0.1875 5.65625 -2.0625q1.625 -1.875 1.625 -5.796875l0 -24.578127q0 -8.171875 7.875 -8.171875l6.140625 0q1.0625 0 1.640625 0.484375q0.578125 0.484375 0.578125 1.25q0 0.859375 -0.578125 1.34375q-0.578125 0.484375 -1.640625 0.484375l-5.65625 0q-4.3125 0 -4.3125 4.40625l0 25.062502q0 4.125 -1.875 6.484375q-1.875 2.34375 -4.65625 2.921875q2.78125 0.578125 4.65625 2.9375q1.875 2.34375 1.875 6.46875l0 25.15625q0 4.421875 4.3125 4.421875l5.65625 0z" fill-rule="nonzero"/><path fill="#000000" d="m47.13736 79.08556q-1.734375 0 -2.734375 -1.03125q-0.984375 -1.046875 -0.984375 -2.78125l0 -56.921875q0 -1.640625 1.03125 -2.625q1.046875 -1.0 2.765625 -1.0l21.5 0q10.0625 0 15.625 4.890625q5.578125 4.890625 5.578125 13.875002q0 8.96875 -5.625 13.953125q-5.609375 4.984375 -15.578125 4.984375l-17.859375 0l0 22.84375q0 1.734375 -1.0 2.78125q-1.0 1.03125 -2.71875 1.03125zm20.84375 -32.8125q14.59375 0 14.59375 -12.78125q0 -12.609377 -14.59375 -12.609377l-17.125 0l0 25.390627l17.125 0z" fill-rule="nonzero"/><path fill="#000000" d="m117.51691 51.554314q2.21875 0.109375 2.21875 1.828125q0 0.671875 -0.578125 1.203125q-0.578125 0.53125 -1.640625 0.625q-4.03125 0.09375 -5.5625 1.96875q-1.53125 1.875 -1.53125 5.90625l-0.203125 24.671875q0 3.9375 -2.015625 6.046875q-2.015625 2.109375 -5.84375 2.109375l-6.15625 0q-1.046875 0 -1.625 -0.484375q-0.578125 -0.484375 -0.578125 -1.25q0 -0.859375 0.578125 -1.34375q0.578125 -0.46875 1.625 -0.46875l5.671875 0q4.3125 0 4.3125 -4.421875l0 -25.15625q0 -4.125 1.875 -6.46875q1.875 -2.359375 4.65625 -2.9375q-2.78125 -0.578125 -4.65625 -2.921875q-1.875 -2.359375 -1.875 -6.484375l0 -25.062502q0 -4.40625 -4.3125 -4.40625l-5.671875 0q-1.046875 0 -1.625 -0.484375q-0.578125 -0.484375 -0.578125 -1.34375q0 -0.765625 0.578125 -1.25q0.578125 -0.484375 1.625 -0.484375l6.15625 0q3.828125 0 5.84375 2.125q2.015625 2.109375 2.015625 6.046875l0 24.578127q0 4.03125 1.625 5.859375q1.640625 1.8125 5.671875 2.0z" fill-rule="nonzero"/></g></svg>',
          syncDisabledState: false,
          onClick: (buttonView, editor) => {
            window.insertPlaceholderModalActiveEditor = editor
            component.$bvModal.show(id)
          },
      }
    },
  }
</script>